import React from 'react';
import { palette } from '@livable/saas-react-components';
import { Box, Container, Typography, Grid } from '@mui/material';
import useStyles from '../../styles';
const shades = palette.shades;
const successColors = palette.success;
const infoColors = palette.info;
const warningColors = palette.warning;
const errorColors = palette.error;
const primary = palette.primary;
const shadesExample = "\nimport { palette } from '@livable/saas-react-components';\n\n{ backgroundColor: palette.shades[800] }";
const gradientsExample = "\nimport { palette } from '@livable/saas-react-components';\n\n{ backgroundColor: palette.gradients.dark }";
const statesExample = "\nimport { palette } from '@livable/saas-react-components';\n\n{ backgroundColor: palette.success.main }";
const brandColorsExample = "\nimport { palette } from '@livable/saas-react-components';\n\n{ backgroundColor: palette.primary.main }";
const brandGradientsExample = "\nimport { palette } from '@livable/saas-react-components';\n\n{ backgroundColor: palette.brandGradients.main }";
const additionalExample = "\nimport { palette } from '@livable/saas-react-components';\n\n{ backgroundColor: palette.secondary.main }";
export default function LvColors() {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    className: classes.section
  }, "System colors"), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "Interface shades"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "shades[100]"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      backgroundColor: shades[100]
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#FFFFFF")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "shades[200]"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      backgroundColor: shades[200]
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#F8F9FA")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "shades[300]"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      backgroundColor: shades[300]
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#E1E7EC")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "shades[400]"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      backgroundColor: shades[400]
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#CFD6DE")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "shades[500]"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      backgroundColor: shades[500]
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#B8C4CE")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "shades[600]"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      backgroundColor: shades[600]
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#8895A7")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "shades[700]"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      backgroundColor: shades[700]
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#4B617C")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "shades[800]"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      backgroundColor: shades[800]
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#212934")), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, shadesExample))), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "Gradients"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "gradients.dark"), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.gradientBox, " ").concat(classes.gradientDark)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "gradients.fade"), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.gradientBox, " ").concat(classes.gradientFade)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "gradients.white"), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.gradientBox, " ").concat(classes.gradientWhite)
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, gradientsExample), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "States"), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Success"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "success.dark"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      background: successColors.dark
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#145239")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "success.main"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      background: successColors.main
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#259D58")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "success.light"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      background: successColors.light
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#E9F7E9")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "success.gradient"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      background: successColors.gradient
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#E9F7E9 > 0%"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Info"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "info.dark"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      background: infoColors.dark
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#1D3A51")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "info.main"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      background: infoColors.main
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#2A85D1")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "info.light"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      background: infoColors.light
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#E3F0FC")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "info.gradient"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      background: infoColors.gradient
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#E3F0FC > 0%"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Warning"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "warning.dark"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      background: warningColors.dark
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#56420D")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "warning.main"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      background: warningColors.main
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#D5A320")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "warning.light"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      background: warningColors.light
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#FFF3E1")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "warning.gradient"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      background: warningColors.gradient
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#FFF3E1 > 0%"))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h4",
    gutterBottom: true
  }, "Error"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "error.dark"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      background: errorColors.dark
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#611818")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "error.main"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      background: errorColors.main
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#C43131")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "error.light"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      background: errorColors.light
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#FCE4E9")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "error.gradient"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      background: errorColors.gradient
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#FCE4E9 > 0%")))), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, statesExample))), /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    className: classes.section
  }, "Brand colors"), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "Brand colors"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "primary.main"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      backgroundColor: primary.main
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#009299")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "primary.dark"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      backgroundColor: primary.dark
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#00767C")), /*#__PURE__*/React.createElement("div", {
    className: classes.colorWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "primary.light"), /*#__PURE__*/React.createElement("div", {
    className: classes.colorBox,
    style: {
      backgroundColor: primary.light
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "#3EBCC1")), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, brandColorsExample), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "Brand gradients"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    className: classes.subsectionName,
    gutterBottom: true
  }, "Main gradient"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "brandGradients.main"), /*#__PURE__*/React.createElement("div", {
    className: classes.brandGradientWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    className: classes.brandGradientFrom
  }, "#009299"), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.brandGradient, " ").concat(classes.brandGradientMain)
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    className: classes.brandGradientTo
  }, "#00B488")), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    className: classes.subsectionName,
    gutterBottom: true
  }, "Fade gradient"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "brandGradients.fade"), /*#__PURE__*/React.createElement("div", {
    className: classes.brandGradientWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.brandGradient, " ").concat(classes.brandGradientFade)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, brandGradientsExample), /*#__PURE__*/React.createElement(Typography, {
    className: classes.subsectionName,
    variant: "h2",
    gutterBottom: true
  }, "Additional"), /*#__PURE__*/React.createElement("div", {
    className: classes.brandGradientWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    className: classes.brandGradientFrom
  }, "#E3005F"), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.brandGradient, " ").concat(classes.brandSecondary)
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.codeSnippet
  }, additionalExample))));
}